var n=function(n,c,r,t,o){var e=[c&&"".concat(n,"-helper"),r&&"".concat(n,"-error"),t&&"".concat(n,"-success"),o&&"".concat(n,"-info")].filter((function(n){return n}));return e.length?e.join(" "):null};export{n as c};
